import { Layout } from "antd";
import { Content } from "antd/lib/layout/layout";
import React from "react";
import "../../styles/AuthLayout.less";

const AuthLayout = ({ children }) => {
	return (
		<Layout style={{ 
			minHeight: "100vh", 
			backgroundImage: "url(/bg-login.png)", 
			backgroundAttachment: "fixed",
			backgroundRepeat: "no-repeat",
			backgroundSize: "cover",
			backgroundPosition: "center"
		}}>
			<Content style={{ margin: 32 }}>
				{children}
			</Content>
		</Layout>
	);
};

export default AuthLayout;
